import React from 'react';
import { useLocation } from 'react-router-dom';
import WebViewIntrusion from './WebViewIntrusion';
import ProtectedRoute from './ProtectedRoute';
import { KioskWebViewAccessGate } from './KioskWebViewAccessGate';
import { isWebViewAuthBypass } from '../utils/webviewAudio';
import { canAccessKioskIntrusionWebview, isKioskMode } from '../utils/kioskMode';

const toLaneNumber = (raw) => {
  if (raw === null || raw === undefined || raw === '') return null;
  const parsed = parseInt(String(raw), 10);
  return Number.isNaN(parsed) || parsed <= 0 ? null : parsed;
};

export const parseIntrusionLaneFromPath = (pathname = '') => {
  const parts = pathname.split('/').filter(Boolean);
  const webviewIdx = parts.findIndex((p) => {
    const lower = String(p).toLowerCase();
    return lower === 'webview-intrusion' || lower === 'webview';
  });
  if (webviewIdx < 0 || webviewIdx + 1 >= parts.length) return null;
  const rawPart = String(parts[webviewIdx + 1] || '');
  let decoded = rawPart;
  try {
    decoded = decodeURIComponent(rawPart);
  } catch (e) {
    decoded = rawPart;
  }
  const compact = decoded.toLowerCase().trim().replace(/\s+/g, '');
  const match =
    compact.match(/^lane(\d+)$/) ||
    compact.match(/^lane-(\d+)$/) ||
    compact.match(/^(\d+)$/);
  return match ? toLaneNumber(match[1]) : null;
};

/** Intrusion webview: intrusion users and admin+intrusion in kiosk; admin+intrusion or intrusion in full app. */
export function IntrusionWebViewRouteGuard() {
  const location = useLocation();
  const laneNumber = parseIntrusionLaneFromPath(location?.pathname || '');

  if (isWebViewAuthBypass()) {
    return <WebViewIntrusion laneNumber={laneNumber} />;
  }

  if (isKioskMode()) {
    return (
      <KioskWebViewAccessGate canAccess={canAccessKioskIntrusionWebview}>
        <WebViewIntrusion laneNumber={laneNumber} />
      </KioskWebViewAccessGate>
    );
  }

  return (
    <ProtectedRoute allowedRoles={['admin', 'intrusion']}>
      <WebViewIntrusion laneNumber={laneNumber} />
    </ProtectedRoute>
  );
}

export default IntrusionWebViewRouteGuard;
